<template>
  <div>
    <button @click="generatePrompt" class="button">Get Inspiration</button>
    <p v-if="prompt">{{ prompt }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prompts: [
        "Write about a time you felt inspired by nature.",
        "What is something you're looking forward to?",
        "Describe a favorite memory from your childhood.",
        "What are some small things that make your day better?",
        "How do you feel about your current life path?",
        "What are your thoughts on the future?",
        "Describe a recent dream you had and what you think it might mean.",
        "List five things you are grateful for today.",
        "What are you grateful for today?",
        "Describe a memory that made you smile recently.",
        "What's something you've learned this week?",
        "Write about a place you'd love to visit someday and why.",
        "What are three goals you have for the next month?",
        "Describe your perfect day.",
        "What challenges have you overcome?",
        "Who inspires you the most, and why?",
        "Write about something you're looking forward to.",
        "Describe a book or movie that deeply affected you.",
        "What are some small things that make your day better?",
        "Write about a friend and what makes your friendship special.",
        "What is a skill you'd like to learn and why?",
        "Describe your favorite hobby and what makes it enjoyable for you.",
        "Reflect on your greatest strength and a situation where it helped you."
      ],
      prompt: null
    };
  },
  methods: {
    generatePrompt() {
      this.prompt = this.prompts[Math.floor(Math.random() * this.prompts.length)];
    }
  }
};
</script>

<style scoped>
.button {
  margin-top: 10px;
  background-color: #007BFF;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.button:hover {
  background-color: #0056b3;
}
</style>
